export type AdmissionStatus = "New" | "Under Review" | "Approved" | "Rejected";

export type AdmissionApplication = {
  appNo: string;
  date: string;
  status: AdmissionStatus;
  applicantName: string;
  applicantMobile: string;
  applicantAddress: string;
  elderName: string;
  fatherName: string;
  age: number;
  village: string;
  taluka: string;
  district: string;
  currentLiving: string;
  physicalCondition: string;
  reason: string;
  contacts: { name: string; relation: string; mobile: string }[];
  pension: string;
  otherIncome: string;
  remarks: string;
};

const statuses: AdmissionStatus[] = ["New", "Under Review", "Approved", "Rejected"];
const firstNames = ["Ramesh", "Sita", "Mohan", "Lata", "Bhanu", "Kalpana", "Jayanti", "Manu", "Hiren", "Pravin", "Ila", "Vikram", "Asha", "Suresh", "Rekha", "Devram", "Geeta", "Naresh"];
const lastNames = ["Patel", "Desai", "Shah", "Parmar", "Joshi", "Modi", "Trivedi", "Vora"];
const villages = ["Anand", "Nadiad", "Bavla", "Sanand", "Bardoli", "Mehsana", "Modasa", "Vyara"];
const talukas = ["Anand", "Kheda", "Nadiad", "Sanand", "Bardoli", "Mehsana"];
const districts = ["Anand", "Kheda", "Ahmedabad", "Surat", "Mehsana", "Sabarkantha"];

function pick<T>(arr: T[], i: number) { return arr[i % arr.length]; }

export const mockAdmissionApplications: AdmissionApplication[] = Array.from({ length: 18 }).map((_, i) => {
  const elderFirst = pick(firstNames, i);
  const elderLast = pick(lastNames, i + 2);
  const appFirst = pick(firstNames, i + 5);
  const day = ((i * 3) % 28) + 1;
  const month = ((i % 12) + 1).toString().padStart(2, "0");
  return {
    appNo: `ADM-2026-${(1001 + i).toString()}`,
    date: `2026-${month}-${day.toString().padStart(2, "0")}`,
    status: statuses[i % statuses.length],
    applicantName: `${appFirst} ${pick(lastNames, i)}`,
    applicantMobile: `+91 9${(80000000 + i * 137).toString().slice(0, 9)}`,
    applicantAddress: `${pick(villages, i)}, ${pick(districts, i)}, Gujarat`,
    elderName: `${elderFirst}bhai ${elderLast}`,
    fatherName: `${pick(firstNames, i + 1)}bhai ${elderLast}`,
    age: 62 + (i % 25),
    village: pick(villages, i),
    taluka: pick(talukas, i + 1),
    district: pick(districts, i),
    currentLiving: i % 3 === 0 ? "Lives alone in ancestral home" : i % 3 === 1 ? "With distant relatives" : "With married son's family",
    physicalCondition: i % 4 === 0 ? "Diabetic, requires daily medication" : i % 4 === 1 ? "Mobility limited, uses walker" : i % 4 === 2 ? "Generally healthy, mild hypertension" : "Vision impaired, needs assistance",
    reason: i % 3 === 0 ? "No family support available" : i % 3 === 1 ? "Family unable to provide regular care" : "Wishes to spend remaining years in spiritual community",
    contacts: [
      { name: `${pick(firstNames, i + 2)} ${pick(lastNames, i + 1)}`, relation: "Son", mobile: `+91 98${(70000000 + i * 91).toString().slice(0, 8)}` },
      { name: `${pick(firstNames, i + 4)} ${pick(lastNames, i + 3)}`, relation: "Neighbour", mobile: `+91 97${(60000000 + i * 73).toString().slice(0, 8)}` },
      { name: `${pick(firstNames, i + 7)} ${pick(lastNames, i + 5)}`, relation: "Cousin", mobile: `+91 96${(50000000 + i * 53).toString().slice(0, 8)}` },
    ],
    pension: i % 2 === 0 ? "₹2,500 / month state pension" : "No pension",
    otherIncome: i % 3 === 0 ? "Small farm rent ₹1,200/month" : "None",
    remarks: i % 2 === 0 ? "Prefers vegetarian satvik food. Speaks Gujarati only." : "Open to shared room. Daily bhajan preferred.",
  };
});
